import { Link } from 'react-router'
import { formatDate } from '@/lib/shipment'
import { Subscription, FlowerCollectionProduct } from '~/api-client/data-contracts'
import { Panel } from '~/components/subscription/panel'

// 次回のお届けに合わせ買いグッズを追加できることを知らせる
export const AddInBulkCard: React.FC<{
  subscription: Subscription
  nextBulkProducts: FlowerCollectionProduct[] // 次回お届け分に追加済みの商品
  inBulkProducts: FlowerCollectionProduct[] // 次回お届け分に追加可能な商品
}> = ({ subscription, nextBulkProducts, inBulkProducts }) => {
  if (!subscription) return null

  const date = formatDate(subscription.attributes.next_deliver_at * 1000, 'M/d（E）')
  const products = inBulkProducts.filter((item) => item.attributes.bulk_discounted_price > 0 && item.attributes.on_sale)

  if (products.length === 0) return null
  if (nextBulkProducts.filter((p) => !p.attributes.name.match(/初回特典/)).length > 0) return null

  return (
    <Panel>
      <h3 className="text-[15px] font-bold text-black leading-relaxed">{date}お届け分にグッズを追加できます</h3>
      <div className="flex flex-col items-start gap-2">
        <div className="grid grid-cols-4 gap-2 py-2 w-full">
          {products.slice(0, 4).map((item) => (
            <Link key={item.id} to="/subscription/rose/mypage/bulk" className="relative block rounded-lg overflow-hidden">
              {item.attributes.bulk_discounted_price < item.attributes.price && (
                <span className="absolute top-1 left-1 bg-accent text-white text-[10px] font-bold px-1.5 py-0.5 rounded">-20%</span>
              )}
              <img src={item.attributes.image_small_url} className="w-full aspect-square object-cover" />
            </Link>
          ))}
        </div>
        <Link to="/subscription/rose/mypage/bulk" className="inline-block px-4 py-2 bg-black text-white text-[13px] font-bold rounded-full">
          すべてのグッズを見る
        </Link>
      </div>
    </Panel>
  )
}
